module.exports = __webpack_public_path__ + "static/media/afgewerkt_color.d4b30dd9.svg";